import styled from 'styled-components'
import { Box, Text } from "@usap/uicomponents"

const darkColor = (props) => props.theme.global.colors['dark-2']
const borderColor = (props) => props.theme.global.colors['divider']

export const AddMoreContainer = styled(Box)`
  opacity: ${props => props.disabled ? '0.5' : '1'};
  height: 120px;
`

export const AddMoreBox = styled(Box)`
  width: 88px;
  height: 88px;
  border: 1px solid ${borderColor};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AddMoreText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: ${darkColor};
  text-align: center;
  margin: 8px 0 0 0;
  line-height: 24px;
`
